// top10TypeOptions 选款分析top10下的来源tab配置项
// 1-淘宝店铺 2-ins博主 3-小红书博主 4-品牌 5-抖音达人 6-抖音小店 7-跨境站点 8-用户插件采集站点
export enum TOP_10_TYPE_ENUM {
  'TAO_BAO_DIAN_PU' = 1,
  'INS_BO_ZHU' = 2,
  'XIAO_HONG_SHU_BO_ZHU' = 3,
  'PIN_PAI' = 4,
  'DY_DA_REN' = 5,
  'DY_DIAN_PU' = 6,
  'KUA_JING_ZHAN_DIAN' = 7,
  'CAI_JI_ZHAN_DIAN' = 8,
}
// const brand = { label: '品牌', value: TOP_10_TYPE_ENUM.PIN_PAI }
// const brandTop10TypeOptions = [brand]

// export const SHARE_TEXT = {
//   0: '不共享',
//   1: '部分成员可见',
//   2: '全员可见'
// }

export const INDUSTRY = { CLOTHING: '服装', SHOES: '鞋靴' }

export const GENDER_VALUE = {
  WOMEN: '女装',
  MEN: '男装',
  CHILD: '童装',
  GIRL: '女童',
  BOY: '男童',
  SHOES: '鞋靴',
}
export const GENDER_OPTIONS = [
  {
    value: '女装',
    label: '女装',
  },
  {
    value: '男装',
    label: '男装',
  },
  {
    value: '童装',
    label: '童装',
  },
  {
    value: '女童',
    label: '女童',
  },
  {
    value: '男童',
    label: '男童',
  },
  {
    value: '鞋靴',
    label: '鞋靴',
  },
  {
    value: '其他',
    label: '其他',
  },
]
export const INDUSTRY_VALUE = {
  [GENDER_VALUE.WOMEN]: '服装',
  [GENDER_VALUE.MEN]: '服装',
  [GENDER_VALUE.CHILD]: '服装',
  [GENDER_VALUE.GIRL]: '服装',
  [GENDER_VALUE.BOY]: '服装',
  [GENDER_VALUE.SHOES]: '鞋靴',
}
export const MARK_STATUS = { UNSET: 0, PASS: 1, NOT_PASS: 2, PENDING: 3 }
export const MARK_TEXT = {
  [MARK_STATUS.UNSET]: '待提审',
  [MARK_STATUS.PASS]: '通过',
  [MARK_STATUS.NOT_PASS]: '拒回',
  [MARK_STATUS.PENDING]: '待审核',
}
export const QUERY_TYPE = {
  /**
   * 拥有
   */
  OWNER: 1,
  /**
   * 协作
   */
  COOPERATION: 2,
  /**
   * 全部
   */
  ALL: 3,
}
export const getMarkStatusText = (markStatus, option: any) => {
  const { level = 0, maxLevel = 0, isPass = false, isNotPass = false } = option || {}

  if (isPass) {
    if (markStatus === MARK_STATUS.PASS) {
      return true
    }
    return false
  }

  if (isNotPass) {
    if (maxLevel === level && markStatus === MARK_STATUS.NOT_PASS) {
      return true
    }
    return false
  }

  const levelEnum = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
  }

  if (markStatus === MARK_STATUS.PASS || markStatus === MARK_STATUS.NOT_PASS) {
    if (markStatus === MARK_STATUS.PASS) {
      return '已通过'
    }
    if (markStatus === MARK_STATUS.NOT_PASS && (level === maxLevel || level === 0)) {
      return '已拒回'
    }
    if (markStatus === MARK_STATUS.NOT_PASS && level !== 0) {
      return `${levelEnum[level]}审${MARK_TEXT[MARK_STATUS.NOT_PASS]}`
    }
  }
  if (
    (markStatus === MARK_STATUS.UNSET || markStatus === MARK_STATUS.PENDING || markStatus === MARK_STATUS.NOT_PASS) &&
    level !== 0
  ) {
    return `${levelEnum[level]}审${MARK_TEXT[MARK_STATUS.PASS]}`
  }
  return MARK_TEXT[markStatus]
}

export const MEMBER_TYPE = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  MEMBER: 3,
}
export const IDEA_MASS_ROLE = {
  OWNER: 2,
  AUDITOR: 1,
  GATHER: 3,
  VIEWER: 4,
  UNSET: 0,
  VISITOR: -1,
} // 2-拥有者，1-审核者, 3-采集者，4-查看者，0-初始化值，-1 访客

export const ROLE_COMPARISON = {
  [IDEA_MASS_ROLE.OWNER]: '拥有者',
  [IDEA_MASS_ROLE.AUDITOR]: '审核者',
  [IDEA_MASS_ROLE.GATHER]: '采集者',
  [IDEA_MASS_ROLE.VIEWER]: '查看者',
}
